import { render, staticRenderFns } from "./FooterLinkModular.vue?vue&type=template&id=5dd12a0c&scoped=true&"
import script from "./FooterLinkModular.vue?vue&type=script&lang=js&"
export * from "./FooterLinkModular.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinkModular.vue?vue&type=style&index=0&id=5dd12a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd12a0c",
  null
  
)

export default component.exports